import styled from 'styled-components'
import { Row } from 'antd'

export { CollapsibleCard } from './CollapsibleCard'
export { SimpleCard } from './SimpleCard'

export const Container = styled(Row)`
  height: 100%;
`
